import { AudioManager, AudioType } from '@colonist/audio';
import { setElementInnerHTML, setElementOnClick } from '../ui_utils/DomUtils.ts';
import { UIUtilsEjsVariables } from '../UIUtilsEjsVariables.ts';
import { CA } from '../analytics/Analytics.ts';
import { AnalyticEventCategory, AnalyticEventType, AnalyticEventValue } from '../../../../shared/entity_datas/EntityDatas.ts';
import { replaceLanguageInPath } from '../ClientI18n.ts';
import { navigateToPage } from '../ui_utils/ClientUtils.ts';
import { ClientUserState } from '../ClientUserState.ts';
export class UICoinsController {
    setCoins(coinAmount) {
        setElementInnerHTML(this.userCoinsDiv, {
            key: 'strings:colonistCommon.utils.#buffer',
            options: {
                value: coinAmount
            }
        });
    }
    initCoinClick() {
        setElementOnClick(this.headerCoinsContainer, ()=>{
            AudioManager.play(AudioType.Click);
            this.sendCoinClickAnalytic();
            const storePath = replaceLanguageInPath('/store', UIUtilsEjsVariables.language);
            navigateToPage(storePath);
        });
    }
    // eslint-disable-next-line class-methods-use-this
    sendCoinClickAnalytic() {
        const eventData = {
            type: AnalyticEventType.ABTestClickAnalytics,
            category: AnalyticEventCategory.ABTestClickAnalytics,
            floatValue: AnalyticEventValue.HeaderCoinPlusButton
        };
        void CA.sendAnalyticEvent(eventData);
    }
    constructor(){
        this.userCoinsDiv = document.getElementById('header_coins');
        this.headerCoinsContainer = document.getElementById('header_coins_container');
        ClientUserState.registerChangeListener((userState)=>{
            if (userState == undefined) return;
            this.setCoins(userState.items.colonistCoins);
        });
        this.initCoinClick();
    }
}
